import * as B from '@blueprintjs/core';
import * as I from 'immutable';
import React from 'react';

import {ApiFeature} from 'app/modules/Remote/Feature';
import {
  AlertNoteType,
  StateApiNote,
  isOwnershipChangeAlert,
  isParcelAreaChangeAlert,
  isVegetationDropAlert,
} from 'app/stores/NotesStore';
import {featureInRegridCoverage} from 'app/utils/featureCollectionUtils';

import {ALERT_TYPE_CONFIGURATIONS} from './alertTypes';

export interface FilterOption {
  id: string;
  label: string;
  color?: string;
  icon: React.ReactElement | null;
  filter: (n: StateApiNote) => boolean;
  // Parcel alerts rely on Regrid parcel data, which only covers the US.
  requiresRegridCoverage?: boolean;
}

export const ALL_FILTER_ID = 'all';

const noop = (_: StateApiNote) => true;

const typeFilterOption = (
  type: Exclude<AlertNoteType, 'customAlert'>,
  filter: FilterOption['filter'],
  requiresRegridCoverage?: boolean
): FilterOption => {
  const {label, icon, color} = ALERT_TYPE_CONFIGURATIONS[type];
  return {
    id: type,
    label,
    color,
    icon: <B.Icon icon={icon} color={color} />,
    filter,
    requiresRegridCoverage,
  };
};

export const DEFAULT_FILTER_OPTIONS: FilterOption[] = [
  {id: ALL_FILTER_ID, label: 'All', icon: null, filter: noop},
  typeFilterOption('vegetationDrop', isVegetationDropAlert),
  typeFilterOption('ownershipChange', isOwnershipChangeAlert, true),
  typeFilterOption('parcelAreaChange', isParcelAreaChangeAlert, true),
];

// The sidebar lists one property's alerts, so the property is what decides whether the parcel
// filters can match anything — a portfolio's bounds cover every property in it.
export function getDefaultFilterOptions(feature: I.ImmutableOf<ApiFeature>): FilterOption[] {
  return featureInRegridCoverage(feature)
    ? DEFAULT_FILTER_OPTIONS
    : DEFAULT_FILTER_OPTIONS.filter((fo) => !fo.requiresRegridCoverage);
}
